<template>
  <div class="overview-section">
    <div class="asset-account-section">
      <div class="section-header">
        <span class="section-title">{{ $t("asset.asset_account") }}</span>
      </div>
      <div class="account-list">
        <div class="account-item" @click="$emit('change-tab', 'rwa')">
          <span class="account-name">{{ $t("asset.rwa_token") }}</span>
          <div class="account-right">
            <div class="account-value">
              <span class="value-amount">{{ overviewData.rwaTokens }}</span>
              <span class="value-currency">{{ legalCurrency }}</span>
              <i class="el-icon-arrow-right" />
            </div>
            <!-- <span class="exchange-rate">1{{ legalCurrency }} ≈ 1 HK$</span> -->
          </div>
        </div>
        <div class="account-item active" @click="$emit('change-tab', 'fund')">
          <span class="account-name">{{ $t("asset.fund") }}</span>
          <div class="account-right">
            <div class="account-value">
              <span class="value-amount">{{ overviewData.funds }}</span>
              <span class="value-currency">{{ legalCurrency }}</span>
              <i class="el-icon-arrow-right" />
            </div>
            <!-- <span class="exchange-rate">1{{ legalCurrency }} ≈ 1 HK$</span> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OverviewSection",
  props: {
    overviewData: {
      type: Object,
      required: true,
    },
    legalCurrency: {
      type: String,
      required: true,
    },
  },
  emits: ["change-tab"],
};
</script>

<style lang="less" scoped>
.overview-section {
  .asset-account-section {
    background-color: #ffffff;
    border-radius: 16px;
    padding: 32px;

    .section-header {
      display: flex;
      align-items: flex-end;
      margin-bottom: 24px;
      border-bottom: 1px solid #e2e3e3;

      .section-title {
        font-size: 18px;
        font-weight: 600;
        color: #333333;
        margin-bottom: 8px;
        position: relative;
        display: inline-block;
      }
      .section-title::before {
        content: "";
        display: inline-block;
        width: 100%;
        height: 2px;
        position: absolute;
        bottom: -8px;
        left: 0;
        background-color: var(--primary-color);
      }
    }

    .account-list {
      .account-item:hover {
        background-color: color-mix(in srgb, var(--primary-color) 10%, transparent);
      }
      .account-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 24px;
        cursor: pointer;
        border-radius: 12px;
        transition: background-color 0.2s;
        margin-bottom: 8px;

        &:last-child {
          margin-bottom: 0;
        }

        .account-name {
          font-size: 16px;
          font-weight: 500;
          color: #333333;
        }

        .account-right {
          display: flex;
          align-items: center;
          flex-flow: column;
          .account-value {
            display: flex;
            align-items: center;
            gap: 8px;

            .value-amount {
              font-size: 18px;
              font-weight: 600;
              color: #333333;
            }

            .value-currency {
              font-size: 18px;
              color: #333333;
            }
            i {
              font-size: 18px;
              color: #333333;
            }
          }

          .exchange-rate {
            font-size: 12px;
            color: #999999;
            white-space: nowrap;
          }

          .arrow {
            font-size: 16px;
            color: #cccccc;
          }
        }
      }
    }
  }
}
</style>
